import React from "react";
import {withStyles} from "@material-ui/core/styles";
import {createStyles} from "@material-ui/core";

const styles = () => createStyles({
    correctDiffAdd: {
        backgroundColor: 'rgb(234, 254, 210)',
        fontSize: 14,
        marginLeft: 5,
        height: 'fit-content',
        position: 'relative',
        top: 12,
        padding: 3
    },
    correctDiffAddHistory: {
        backgroundColor: 'rgb(234, 254, 210)',
        fontSize: 14,
        marginLeft: 5,
        padding: 3
    }
})

/**
 * Комопнент для отображения изменений позиций в тесте послежорвательности.
 */
const SequenceChanges = withStyles(styles)(({classes, answer, historyMode}: any) => {
    const classAdd = historyMode ? classes.correctDiffAddHistory : classes.correctDiffAdd

    return (
        <div className={classAdd}>
            <span>установил(а) позицию</span>
            &nbsp;
            {answer.authorCorrectChange}
        </div>
    )
});

export default SequenceChanges